import React from 'react';
import { LEVEL_META, LEVEL_ORDER } from '../bb/bbShared';

export const TemperatureStep = ({ value, onChange }) => {
  const level = value?.level || '';
  return (
    <div className="space-y-5 animate-fade-in" data-testid="temperature-step">
      <div>
        <h3 className="text-xl font-bold uppercase" style={{ fontFamily: 'var(--font-display)' }}>Selon vous, ce dossier est…</h3>
        <p className="text-sm text-slate-500">Votre avis alimente le Business Commercial de la Direction. Il pourra être ajusté en point commercial.</p>
      </div>
      <div className="relative">
        <div className="hidden md:block absolute left-6 right-6 top-[34px] h-1.5 rounded-full" style={{ background: 'linear-gradient(90deg,#D1361F,#F26A1B,#E3A21A,#6C8EAD,#8A857E)' }} />
        <div className="grid grid-cols-1 md:grid-cols-5 gap-3 relative" role="radiogroup">
          {LEVEL_ORDER.map(k => {
            const m = LEVEL_META[k]; const on = level === k; const Icon = m.icon;
            return (
              <button key={k} type="button" role="radio" aria-checked={on} onClick={() => onChange('level', k)} data-testid={`temperature-${k}`}
                className={`flex md:flex-col items-center md:text-center gap-3 rounded-2xl border-2 p-4 bg-white transition-[transform,border-color,box-shadow] duration-200 hover:-translate-y-0.5 ${on ? 'shadow-lg' : 'border-slate-200 hover:border-slate-300'}`}
                style={on ? { borderColor: m.fg, background: m.bg } : undefined}>
                <span className="w-11 h-11 shrink-0 rounded-full flex items-center justify-center ring-4 ring-white" style={{ background: on ? m.fg : m.bg, color: on ? '#fff' : m.fg }}><Icon className="w-5 h-5" /></span>
                <span className="text-left md:text-center">
                  <span className="block font-bold text-base" style={{ color: m.fg, fontFamily: 'var(--font-display)' }}>{m.label} <span className="text-sm">({m.pct})</span></span>
                  <span className="block text-xs text-slate-600 mt-0.5 leading-snug">{m.hint}</span>
                </span>
              </button>
            );
          })}
        </div>
      </div>
      <div>
        <label htmlFor="temperature-comment" className="text-sm font-semibold text-slate-700">Commentaire (facultatif)</label>
        <textarea id="temperature-comment" rows={3} value={value?.comment || ''} onChange={e => onChange('comment', e.target.value)} data-testid="temperature-comment"
          className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-300" placeholder="Points à vérifier par le client, concurrence, décideur rencontré…" />
      </div>
    </div>
  );
};
